// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.login-m_htVZEXa7eZ69WyZ55WTr {
    background-color: white;
    margin-bottom: 1.5rem;
    width: 30vw;
}

.rs-theme-dark .login-m_htVZEXa7eZ69WyZ55WTr {
    background-color: rgb(15, 19, 26);
}

.login-m_UKgdpay4NZP8CywLT7rH {
    border-bottom: 1px solid var(--rs-gray-300);
    background-color: white;
    width: 100%;
}

.rs-theme-dark .login-m_UKgdpay4NZP8CywLT7rH {
    background-color: rgb(15, 19, 26);
    border-bottom: 1px solid var(--rs-gray-600);
}

.login-m_KfiQnxwcxUG73d2fMnFi {
  width: 60vw;
  margin: 0 auto;
  justify-content: space-between
}

.login-m_HI95Jg4vXA5n4GLeDNv4 {
    margin: 0 auto;
    width: 60vw;
    padding: 2rem;
    flex-grow: 1;
}

.login-m_K1YzD3d96gk6GKlc46mV {
    display: flex;
    width: 100%;
    justify-content: center;
    background-color: oklch(0.21 0.034 264.665);
}

@media (max-width: 480px) {
    .login-m_htVZEXa7eZ69WyZ55WTr {
        width: 90vw;
    }

    .login-m_KfiQnxwcxUG73d2fMnFi {
        width: 90vw;
    }

    .login-m_HI95Jg4vXA5n4GLeDNv4 {
        width: 90vw;
    }
}`, "",{"version":3,"sources":["webpack://./client/login/login.m.css"],"names":[],"mappings":"AAAA;IACI,uBAAuB;IACvB,qBAAqB;IACrB,WAAW;AACf;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,2CAA2C;IAC3C,uBAAuB;IACvB,WAAW;AACf;;AAEA;IACI,iCAAiC;IACjC,2CAA2C;AAC/C;;AAEA;EACE,WAAW;EACX,cAAc;EACd;AACF;;AAEA;IACI,cAAc;IACd,WAAW;IACX,aAAa;IACb,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,WAAW;IACX,uBAAuB;IACvB,2CAA2C;AAC/C;;AAEA;IACI;QACI,WAAW;IACf;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,WAAW;IACf;AACJ","sourcesContent":[".panel {\n    background-color: white;\n    margin-bottom: 1.5rem;\n    width: 30vw;\n}\n\n:global(.rs-theme-dark) .panel {\n    background-color: rgb(15, 19, 26);\n}\n\n.header {\n    border-bottom: 1px solid var(--rs-gray-300);\n    background-color: white;\n    width: 100%;\n}\n\n:global(.rs-theme-dark) .header {\n    background-color: rgb(15, 19, 26);\n    border-bottom: 1px solid var(--rs-gray-600);\n}\n\n.headerContent {\n  width: 60vw;\n  margin: 0 auto;\n  justify-content: space-between\n}\n\n.bodyContent {\n    margin: 0 auto;\n    width: 60vw;\n    padding: 2rem;\n    flex-grow: 1;\n}\n\n.footer {\n    display: flex;\n    width: 100%;\n    justify-content: center;\n    background-color: oklch(0.21 0.034 264.665);\n}\n\n@media (max-width: 480px) {\n    .panel {\n        width: 90vw;\n    }\n\n    .headerContent {\n        width: 90vw;\n    }\n\n    .bodyContent {\n        width: 90vw;\n    }\n}"],"sourceRoot":""}]);
// Exports
export var panel = `login-m_htVZEXa7eZ69WyZ55WTr`;
export var header = `login-m_UKgdpay4NZP8CywLT7rH`;
export var headerContent = `login-m_KfiQnxwcxUG73d2fMnFi`;
export var bodyContent = `login-m_HI95Jg4vXA5n4GLeDNv4`;
export var footer = `login-m_K1YzD3d96gk6GKlc46mV`;
export default ___CSS_LOADER_EXPORT___;
